<template>
    <div>
        <h2>担当サーベイ一覧</h2>
        <v-spacer></v-spacer>
        <data-table :data="answer_sheets" @editItem="editItem"></data-table>

    </div>
</template>

<script>
import DataTable from "@/components/surveys/data_table.vue"
import db from '@/components/firebaseInit'
import { mapMutations, mapGetters} from 'vuex'


export default {
    components: {
        DataTable,
    },
    data() {
        return {
            dialog: false,
            surveys: {},
            answer_sheets: [],
            question_paper: []
        }

    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn', 'user'])
    },
    mounted() {
        // this.changeLoadingState(true)
        this.updateSurveys()
    },
    methods: {
        editItem(e) {
            this.$router.push({ name: "answer", params: { company_id: this.$route.params.company_id, survey_id: e.survey_id, answer_sheet_id: e.id } })
        },
        closeDialog() {
            this.updateSurveys()
            this.dialog = false
        },
        async updateSurveys() {
            this.surveys = {}
            this.answer_sheets = []

            const now = Math.floor((new Date()).getTime() / 1000) - 60*60*24*30
            const surveys = await db.collection("companies").doc(this.$route.params.company_id).collection("surveys").where("end_date", ">", now).get()
            surveys.forEach((doc) => {
                this.surveys[doc.id] = doc.data()

                this.updateAnswerSheets(doc.id)
            })
        },
        async updateAnswerSheets(doc_id, survey_name) {
            const sheets = await db.collection("companies").doc(this.$route.params.company_id).collection("surveys").doc(doc_id).collection("answer_sheets").get()
            .catch(e => console.log(e))
            sheets.forEach(s => {
                const sheet = s.data()
                if (sheet.user_id == this.user.uid) {
                    sheet.survey_name = this.surveys[doc_id].name
                    sheet.start_date = this.surveys[doc_id].start_date
                    sheet.end_date = this.surveys[doc_id].end_date
                    sheet.pre_end_date = this.surveys[doc_id].pre_end_date
                    sheet.survey_id = doc_id
                    sheet.id = s.id
                    this.answer_sheets.push(sheet)
                }
            })
            this.changeLoadingState(false)
        },
        ...mapMutations('app', ['changeLoadingState'])
    },
    created: function () {
    }

}
</script>
<style lang="scss" scoped>
</style>